<script lang="ts">
  import type { SerializedUnorderedListBlock } from '../../types'

  let { block }: { block: SerializedUnorderedListBlock } = $props()
</script>

<ul class="unordered-list">
  {#each block.items as item}
    <li class={['unordered-list-item', { '-style-classic': block.style === 'classic', '-style-structured': block.style === 'structured' }]}>
      {#if block.style === 'structured'}
        <span class="unordered-list-check">
          <svg class="unordered-list-check-icon" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M3 8.5l3 3 7-7" />
          </svg>
        </span>
      {/if}
      <span class="unordered-list-text">{item}</span>
    </li>
  {/each}
</ul>

<style>
  .unordered-list {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--space-5);
  }

  .unordered-list-item.-style-classic {
    position: relative;
    padding-inline-start: var(--space-8);
  }

  .unordered-list-item.-style-classic::before {
    content: '';
    position: absolute;
    inset-inline-start: 0;
    top: 0.6em;
    width: 6px;
    height: 6px;
    border-radius: var(--radius-6);
    background-color: var(--color-variant-brand);
  }

  .unordered-list-item.-style-structured {
    display: flex;
    align-items: flex-start;
    gap: var(--space-5);
  }

  .unordered-list-check {
    flex: none;
    width: 20px;
    height: 20px;
    margin-top: 2px;
    border-radius: var(--radius-6);
    background-color: var(--color-variant-success-muted);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .unordered-list-check-icon {
    width: 10px;
    height: 10px;
    fill: none;
    stroke: var(--color-variant-success);
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .unordered-list-text {
    font-size: var(--font-size-5);
    line-height: var(--line-height-5);
  }
</style>
